import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import './App.css';
import BookingForm from './BookingForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faSoundcloud } from '@fortawesome/free-brands-svg-icons';

// Custom Resident Advisor icon component - actual RA logo representation
const ResidentAdvisorIcon = () => (
  <svg 
    className="fa-icon" 
    viewBox="0 0 83 40" 
    fill="currentColor"
    style={{ width: '2.5rem', height: '1.5rem' }}
    aria-label="RA logo"
  >
    <title>RA</title>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M82.092 32.018c.556-.533.908-1.28.908-2.113 0-.802-.38-1.523-.9-2.051L58.665 4.3l-7.073 7.11 18.45 18.543h-26.14c-1.278-.038-2.29-.469-3.147-1.304l-11.73-11.788a6.828 6.828 0 00-4.689-1.888l-.017.001H10.004v-4.92h14.825c2.938.002 5.559 1.21 7.48 3.15l8.749 8.793 7.073-7.11-8.92-8.963C35.485 2.234 30.45 0 24.805 0H0v25.027h20.978v.002a4.919 4.919 0 013.486 1.48L35.95 38.053A6.74 6.74 0 0040.449 40h31.733a4.911 4.911 0 003.423-1.45l6.491-6.524-.004-.008" fill="currentColor"></path>
    </g>
  </svg>
);

const artistData = {
  'alexa-fluor': {
    name: 'ALEXA FLUOR',
    image: '/images/AlexaFluor-Portrait.jpg',
    bio: (
        <>
          <span className="highlight">Alexa Fluor</span> is a genre-fluid DJ known for blending emotions with pulsating, bouncy beats.
          Her live sets are transformative, filled with passion and an electric atmosphere. It's not for nothing that she has already
          played on big stages like the Close Festival and at VERKN!PT in 2024. Her music isn't just heard; it's felt, making her a
          standout in the music scene. To truly understand her, you must experience her live.
        </>
      ), 
      socialLinks: {
        instagram: 'https://www.instagram.com/alexa_fluor_/',
        soundcloud: 'https://soundcloud.com/alexa_fluor',
        residentAdvisor: 'https://de.ra.co/dj/alexafluor',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/FW7n3pSgQ4M?si=bqheM03LEJ9iajXi',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2211411833&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'carotin': {
    name: 'CAROTIN',
    image: '/images/Carotin-Portrait-3.jpg',
    bio: (
        <>
        At 150 bpm, <span className="highlight">Carotin</span>'s heart starts beating. The Dresden trance mouse feels most at home where
        the bass is pumping, the tracks don't take themselves too seriously, and of course, wherever the party is going off. The main thing
        is that the energy level is maxed out and the crowd is sweating. In Dresden, she's not just behind the decks – she's also a curator
        with the collectives GlitzerGlanz and Groove Rebellion.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/caarotin/',
        soundcloud: 'https://soundcloud.com/caarotin',
        residentAdvisor: 'https://de.ra.co/dj/carotin',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/OlJQlAeRJSQ?si=8HhV_VkmUmn8T2f-',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2211390020&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true',
      ],
    },
  'eloisa': {
    name: 'ELOISA',
    image: '/images/ELOISA-Portrait-2.jpeg',
    bio: (
        <>
         DJ and Producer <span className="highlight">ELOISA</span>  refuses to be confined by genre conventions. Her sound is fast-paced, driving and emotionally charged.
         With a strong focus on storytelling, she crafts immersive sets that evolve with intention. Hypnotic grooves blend into uplifting trance textures, bouncy rhythms
         dissolve into powerful, high-energy peaks. Behind the decks, <span className="highlight">ELOISA</span> brings a lively and magnetic presence – creating moments that
         are euphoric, powerful and deeply connected to the dance floor.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/eloisa__dj/',
        soundcloud: 'https://soundcloud.com/eloisa_lpz',
        residentAdvisor: 'https://de.ra.co/dj/eloisa',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/rYIpiQF298g?si=Xva5KcmDozwSdOme',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2119378887&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'gianni': {
    name: 'GIANNI',
    image: '/images/Gianni-Portrait.jpg',
    bio: (
        <>
        <span className="highlight">Gianni</span> is here to spread diva propaganda. Always looking stylish and fierce, she is known for an energy that lights up the entire dancefloor.
        As a co-host of akt-party <span className="highlight">Gianni</span> knows what makes a club vibrate. Playing tracks that range from energetic house, rumbling groove and c*nty
        latin influenced techno. She shows up and gets the dancefloor so hot, not even the straight can resist to shake a$$.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/gianniiidj/',
        soundcloud: 'https://soundcloud.com/djgianniii',
        residentAdvisor: 'https://de.ra.co/dj/djgianni',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/t3opfIViXOg?si=yrGK9khjp9L8HzTW',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2148210738&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'krash-cora': {
    name: 'KRASH CORA',
    image: '/images/Krash-Cora-Portrait.jpg',
    bio: (
        <>
        <span className="highlight">Krash Cora</span> is a Berlin-based techno-focused DJ and producer known for her energetic sound. Her sets
        blend powerful basslines with exciting rhythms, organic percussions and captivating melodies. Elements from acid techno, UK-inspired sounds
        and references to old-school trance create synergies with the high-energy spirit of contemporary club music -- always with a sharp focus on
        crowd connection and shared joy. Central to Cora's creative vision is a dedicated pursuit of escapism and euphoria, transforming the performance
        into a resonant music journey.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/krash.cora/',
        soundcloud: 'https://soundcloud.com/krash_cora',
        residentAdvisor: 'https://ra.co/dj/krashcora',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/hbbR_n4odb4?si=Z3vEQEws5BOrD6lF',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/voyeuristic_disorder/krash-cora-065&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'maudux': {
    name: 'MAUDUX',
    image: '/images/Maudux-Portrait.jpg',
    bio: (
        <>
        <span className="highlight">MAUDUX</span> is a DJ and producer blending trance, bouncy techno, and her signature Bounce Trap - a fusion of
        ghetto trance kicks and trap vocals. Her sets feature sharp, carefully crafted track selections known for building and sustsaining intense
        energy. First brought into the spotlight through two standout Radio Rudina appearances,  <span className="highlight">MAUDUX</span> has proven
        her technical skill and creativity turn every performance into a collective experience.<br></br><br></br>
        In the studio, her productions combine rolling basslines, powerful buildups, and sharp vocals to move crowds and create lasting dancefloor moments.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/maudux_/',
        soundcloud: 'https://soundcloud.com/mauduxx',
        residentAdvisor: 'https://ra.co/dj/maudux',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/6zCJvMO1YKE?si=pvHep2pqw2q9sxtK',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2163563880&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'melanchromie': {
    name: 'MELANCHROMIE',
    image: '/images/Melanchromie-Portrait-2.jpg',
    bio: (
        <>
        Delivering sets that hit straight to the heart, <span className="highlight">Melanchromie</span> blends emotional synths with juicy acid sounds
        and driving rhythms. Her style moves between techno and classic trance with a psychedelic twist. Off the decks, she works on her own productions
        and captures other artists through her lens as a photographer.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/melanchromie/',
        soundcloud: 'https://soundcloud.com/melanchromie',
        residentAdvisor: 'https://de.ra.co/dj/melanchromie',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/XQI_XlAwSTM?si=ocbaPchz0awTEznQ',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2030852268&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'millie-forsberg': {
    name: 'MILLIE FORSBERG',
    image: '/images/MillieForsberg-Portrait.jpg',
    bio: (
        <>
        <span className="highlight">Millie Forsberg</span> is a Berlin-based DJ and producer delvering euphoric, high-energy trance and hard trance sets
        combined with elements of hard techno. Her productions are uplifting, featuring catchy vocals and 90s-inspired melodies. She has built recognition 
        through releases on OBSCUUR and Union Trance Mission, as well as performances at TELETECH, HÖR Berlin, and appearances on Sunshine Live.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/millieforsbergmusic/',
        soundcloud: 'https://soundcloud.com/millieforsberg',
        residentAdvisor: 'https://ra.co/dj/millieforsberg',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/x9JuPYDVFm8?si=kFKmp1bbGKmrh4nt',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1925868947&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    },
  'skkin-velvet': {
      name: 'SKKIN VELVET',
      image: '/images/SKKINVELVET-Portrait.png',
      bio: (
          <>
          <span className="highlight">SKKIN VELVET</span> delivers high-intensity trance, hard dance, hard techno, and neo rave. She is a resident at Hamburg's Fundbureau,
          a former resident of VER and the founder of the Kinetik event series. She has performed for TELETECH, HIVE, and Rave the Planet, sharing stages with Amelie Lens,
          OGUZ, Marlon Hoffstadt, Mischluft, Funk Tribu, Hannah Laing, and Novah. Intense, precise, and built for movement. Buckle up.
          </>
        ),
        socialLinks: {
          instagram: 'https://www.instagram.com/skkinvelvet/',
          soundcloud: 'https://soundcloud.com/skkinvelvet',
          residentAdvisor: 'https://ra.co/dj/skkinvelvet',
        },
        youtubeEmbed: 'https://www.youtube.com/embed/YJe96mf6s-g?si=E8ogL3tOFhVIoztK',
        soundcloudEmbeds: [
          'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2368572425&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
        ],
    }, 
  'vivienna': {
    name: 'Vivienna',
    image: '/images/Vivienna-Portrait.jpg',
    bio: (
        <>
        <span className="highlight">Vivienna</span>, a genre-fluid DJ renowed for her skill in creating diverse and groovy nights, fills her sets with
        energy and rhythm. Through multi-deck layering, she seamlessly blends different genres into a unique sound. Her versatility and technical finesse
        ensure a memorable night for everyone on the dance floor.
        </>
      ),
      socialLinks: {
        instagram: 'https://www.instagram.com/viviennepohl/',
        soundcloud: 'https://soundcloud.com/vivienna_dj',
        residentAdvisor: 'https://ra.co/dj/vivienna',
      },
      youtubeEmbed: 'https://www.youtube.com/embed/MT0HtvWw3GI?si=seLWTKkwc1MWz-og',
      soundcloudEmbeds: [
        'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2251348247&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
      ],
    }, 
  'yenkov': {
      name: 'Yenkov',
      image: '/images/Yenkov-Portrait.jpg',
      bio: (
          <>
          A prominent figure in the French electronic scene, <span className="highlight">Yenkov</span> crafts a universe where techno, trance,
          and percussive rhythms meet seamlessly. Moving between multiple aesthetics within a single set, she builds rich, fluid trajectories that 
          offer both an immersive experience and a direct invitation to dance, guided by a sincere, music-centered approach and a strong sensitivity
          to atmosphere. A recognized producer, she has released two EPs and appears in around 15 Various Artists compilations, reflecting a steady
          musical evolution. Rooted in the French scene but increasingly active across Europe, Yenkov is based in Marseille, where she is a part of
          the Animals Industry collective and co-founder of the club Unité.22.
          </>
        ),
        socialLinks: {
          instagram: 'https://www.instagram.com/yenkov.yo/',
          soundcloud: 'https://soundcloud.com/yenkov',
          residentAdvisor: 'https://ra.co/dj/yenkov',
        },
        youtubeEmbed: 'https://www.youtube.com/embed/fHdZgeO7wsU?si=TOdRFUwZI3e22ayE',
        soundcloudEmbeds: [
          'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2109298113&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
        ],
    }, 
    'yova': {
      name: 'YOVA',
      image: '/images/YOVA-Portrait.jpeg',
      bio: (
          <>
          <span className="highlight">YOVA's</span> sound is shaped by euphoric melodies, driving rhythms and a serious love for acid.
          While she doesn't like being tied to one genre, trance has remained the most constant and defining influence throughout her musical
          journey.<br></br><br></br>
          Inspired by the late 90s and early 00s, nostalgia and dreamy elements often find their way into her sets. Her love for the old-school
          sound also led her to start playing vinyl, a side of her practice she is increasingly exploring.
          </>
        ),
        socialLinks: {
          instagram: 'https://www.instagram.com/yyyovaaa/',
          soundcloud: 'https://soundcloud.com/yyyovaaa',
          residentAdvisor: 'https://ra.co/dj/YOVA',
        },
        youtubeEmbed: 'https://www.youtube.com/embed/8npu-vG23N4?si=4Sviz19XA-8kxr0g](https://www.youtube.com/embed/8npu-vG23N4?si=4Sviz19XA-8kxr0g',
        soundcloudEmbeds: [
          'https://www.youtube.com/embed/euy3G9EAdxQ?si=PNNInq_Fp4qnx4if](https://www.youtube.com/embed/euy3G9EAdxQ?si=PNNInq_Fp4qnx4if'
        ],
    }, 
};


function ArtistDetail() {
  const { slug } = useParams();
  const artist = artistData[slug];

  const parallaxRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const parallaxOffset = scrollY * -0.08; // subtle movement upward
      if (parallaxRef.current) {
        parallaxRef.current.style.transform = `translateY(${parallaxOffset}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  
  if (!artist) return <div>Artist not found</div>;

  return (
    <div className="artist-detail">
      <div className="artist-image-wrapper">
        <img
          src={artist.image}
          alt={artist.name}
        />
      </div>
      
      <div className="parallax-content" ref={parallaxRef}>
        <div className="artist-bio">
          <p className="paragraph-text">
            {artist.bio}
          </p>
          </div>

        <div className="artist-links">
            <a href={artist.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
              <FontAwesomeIcon icon={faInstagram} className="fa-icon" />INSTAGRAM
            </a>
            <a href={artist.socialLinks.soundcloud} target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
              <FontAwesomeIcon icon={faSoundcloud} className="fa-icon" />SOUNDCLOUD
            </a>
            <a href={artist.socialLinks.residentAdvisor} target="_blank" rel="noopener noreferrer" className="social-link yellow-strike">
              <ResidentAdvisorIcon />RESIDENT ADVISOR
            </a>
        </div>

        <div className="media-embeds">
            {artist.youtubeEmbed && (
              <iframe
                className="embed-frame"
                src={artist.youtubeEmbed}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}

            {artist.soundcloudEmbeds && artist.soundcloudEmbeds.length > 0 && (
              artist.soundcloudEmbeds.map((embedUrl, index) => (
                <iframe
                  key={index}
                  className="embed-frame"
                  src={embedUrl}
                  scrolling="no"
                  frameBorder="no"
                  allow="autoplay"
                ></iframe>
              ))
            )}
        </div>

      <BookingForm />
  </div>
</div>

    
  );
}

export default ArtistDetail;